import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CRMService } from '../../services/crm.service';
import { NotificationService } from '../../services/notification.service';
import { UtilService } from '../../services/util.service';
import {
    Customer,
    CustomerLookup,
    Opportunity,
    SearchCustomer
} from '../../models/models';

@Component({
    selector: 'customer-child-form',
    templateUrl: './customer-child-form.component.html',
    standalone: false
})
export class CustomerChildForm implements OnChanges {
    @Input() parentCustomerID: number = 0;
    @Input() opportunity: Opportunity = {} as Opportunity;
    @Output() onRefresh = new EventEmitter<any>();

    public searchCustomer: SearchCustomer = {} as SearchCustomer;
    private customer: Customer = {} as Customer;
    private customerID: number = 0;

    public formGroup: UntypedFormGroup = new UntypedFormGroup({
        customerCtrl: new UntypedFormControl('')
    });

    constructor(private crmService: CRMService, private notificationService: NotificationService, private utilService: UtilService) {
    }

    ngOnInit() {
        //console.log("ngOnInit", this.customerCarrierExclusionMapID, this.carrierID);
    }

    ngOnChanges() {
        //console.log("ngOnChanges", this.customerCarrierExclusionMapID, this.carrierID);
    }

    public onCustomerChange(evt: any, ctrl: string) {
        var selectedCustomer = this.formGroup.controls[ctrl].value as CustomerLookup;

        if (ctrl == "customerCtrl") {
            this.searchCustomer = {} as SearchCustomer;
            if (!isNaN(evt) && evt != null) {
                this.customerID = evt;
            }
            else {
                this.customerID = selectedCustomer.customerID;
            }
            this.getCustomer(this.customerID, "customer", true);
        }
    }

    private getCustomer(customerID: number, customerType: string, isChange: boolean) {
        this.crmService.getSearchCustomerByID(customerID).subscribe(result => {
            var cust: SearchCustomer = result.resultCollection[0];
            if (customerType == "customer") {
                this.searchCustomer = Object.assign({}, cust);
            }
        });
        this.crmService.getCustomerById(customerID).subscribe(result => {
            var cust: Customer = result;
            if (customerType == "customer") {
                this.customer = Object.assign({}, cust);
                this.customer.parentCustomerId = this.parentCustomerID;
            }
            //console.log("getCustomer", customerID, this.customerID, this.customer);
        });
    }

    public save() {
        this.utilService.isLoading = true;
        //console.log("save", this.customer);
        this.crmService.saveCustomer(this.customer).subscribe(result => {
            this.utilService.isLoading = false;
            this.onRefresh.emit();
        });

        this.searchCustomer = {} as SearchCustomer;
        this.customer = {} as Customer;
    }

    public cancel() {
        this.onRefresh.emit();
    }
}